import { useState } from 'react'
import { useInView } from '../../hooks/useInView'
import { GOALS, reachGoal } from '../../lib/metrika'
import { ReminderModal } from '../ReminderModal'

const TAGS = [
  { icon: '⚙️', label: 'Без интеграций' },
  { icon: '💰', label: 'Бюджет от 10 000' },
  { icon: '⚡', label: 'Регистрация в 2 шага' },
]

function fadeUp(inView: boolean, delay: number) {
  return {
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0)' : 'translateY(24px)',
    transition: `opacity 0.65s cubic-bezier(0.45,0,0.15,1) ${delay}ms, transform 0.65s cubic-bezier(0.45,0,0.15,1) ${delay}ms`,
  }
}

export function CtaFinal() {
  const { ref, inView } = useInView(0.5, '0px 0px -80px 0px')
  const [reminderOpen, setReminderOpen] = useState(false)
  return (
    <section className="px-4 sm:px-6 lg:px-5">
      <div
        className="relative mx-auto flex max-w-[1920px] flex-col items-center gap-8 overflow-hidden rounded-[30px] px-6 py-14 text-center sm:py-20 lg:px-[10%] lg:py-28"
        style={{
          background: 'linear-gradient(180deg, #e8f3ff 0%, #d6eafe 55%, #b5d9ff 100%)',
        }}
      >
        {/* Pill tags */}
        <div ref={ref} className="flex flex-wrap items-center justify-center gap-4" style={fadeUp(inView, 0)}>
          {TAGS.map(({ icon, label }) => (
            <div
              key={label}
              className="group flex items-center gap-1.5 rounded-[8px] bg-white px-[17px] py-2"
              style={{ boxShadow: '0px 0px 0px 2px rgba(0,0,0,0.1)' }}
            >
              <span className="inline-block text-[16px] leading-6 group-hover:animate-wiggle">{icon}</span>
              <span className="whitespace-nowrap bg-gradient-to-t from-[#3f3f46] to-black bg-clip-text text-[16px] leading-6 text-transparent">
                {label}
              </span>
            </div>
          ))}
        </div>

        <h2
          className="font-display text-[28px] max-[359px]:text-[24px] font-semibold leading-[1.12] tracking-[-0.5px] text-[#041527] sm:text-[42px] sm:tracking-[-1px] md:text-[58px] lg:text-[82px] lg:leading-[91.913px]"
          style={fadeUp(inView, 120)}
        >
          Начните привлекать
          <br />
          клиентов уже сегодня
        </h2>

        <p
          className="font-body text-[15px] leading-[23px] text-[#394959] sm:text-[16px] sm:leading-[26px] lg:text-[20px] lg:leading-[30px]"
          style={fadeUp(inView, 240)}
        >
          Регистрация займёт всего пару минут. Настройте свою первую акцию и&nbsp;смотрите,
          <br className="hidden sm:inline" />
          <span className="sm:hidden"> </span>
          как&nbsp;в&nbsp;личном кабинете появляются горячие заявки.
        </p>

        {/* Две кнопки: основная — регистрация, вторичная — «напомнить позже»
            для тех, кто не готов регистрироваться прямо сейчас. На узких
            экранах кнопки встают в колонку и тянутся на ширину контейнера. */}
        <div
          className="flex w-full flex-col items-stretch gap-3 sm:w-auto sm:flex-row sm:items-center sm:gap-4"
          style={fadeUp(inView, 360)}
        >
          <a
            href="https://lk.ris.promo/auth/register"
            onClick={() => reachGoal(GOALS.signupClick, { place: 'финальный CTA' })}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center rounded-full px-[30px] py-[14px] text-[20px] font-medium leading-7 tracking-[-0.2px] text-white transition duration-300 ease-out hover:brightness-110 active:brightness-90"
            style={{
              background: 'linear-gradient(180deg, #0d6fe0 0%, #145aff 100%)',
              boxShadow:
                '0px 0.602px 0.602px -1.25px rgba(0,0,0,0.18), 0px 2.289px 2.289px -2.5px rgba(0,0,0,0.16), 0px 10px 10px -3.75px rgba(0,0,0,0.06), inset 0px -0.301px 0.241px -1.167px rgba(71,136,255,0.68), inset 0px -1.144px 0.915px -2.333px rgba(71,136,255,0.61), inset 0px -5px 4px -3.5px rgba(71,136,255,0.3)',
            }}
          >
            Создать аккаунт
          </a>

          <button
            type="button"
            onClick={() => {
              reachGoal(GOALS.reminderOpen, { place: 'финальный CTA' })
              setReminderOpen(true)
            }}
            className="inline-flex items-center justify-center rounded-full bg-white px-[30px] py-[14px] text-[20px] font-medium leading-7 tracking-[-0.2px] text-[#041527] transition duration-300 ease-out hover:bg-[#f4f8ff] active:bg-[#e8f0ff]"
            style={{ boxShadow: '0px 0px 0px 2px rgba(4,21,39,0.08), 0px 6px 16px -8px rgba(4,21,39,0.25)' }}
          >
            Напомнить позже
          </button>
        </div>
      </div>

      {reminderOpen && <ReminderModal onClose={() => setReminderOpen(false)} />}
    </section>
  )
}
